export default class CourseMenu
  constructor: (@canteen, @date, @course, @meals) ->
